/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/cuddles/"

const CUDDLES: CommunityData = {
  code: "cuddles",
  inviteCode: "cuddles",
  name: "Cuddles",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/cud-030`,
  waitlist: true,
  socials: {},
  styles: {
    global: {
      counterColor: "#ca3c3a",
      werzLogoColor: "#ffffff",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[166px] h-[94px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[166px] h-[94px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ebebeb",
      asideBg: "#ca3c3a",
      // Custom override: no gap, no padding, no bg on the aside — border only
      asideStyles: "!p-0 !gap-0 border-r border-[#8d8d8d]",
      contentBg: "#ebebeb",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['NeuzeitOfficeRegular']",
      primaryButton:
        "bg-[#ca3c3a] border-2 border-[#ca3c3a] px-[18px] !text-[#ffffff] font-['OswaldMedium'] !text-[17px] leading-[100%] uppercase text-left !h-[50px] sm:!h-[50px]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#8d8d8d]",
      separator: "border-[#ffffff]",
      item: "text-[#ffffff] font-['OswaldMedium'] text-[17px] leading-[100%] uppercase text-center gap-x-[10px] text-opacity-50 border-b border-[#ffffff] !pl-0 !py-4",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ebebeb] !pb-8",
      titles: "text-[#000000] font-['OswaldMedium'] text-[28px] leading-[120%] text-left",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#000000] font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#8d8d8d]",
        sectionTitle:
          "text-[#000000] font-['OswaldMedium'] text-[28px] leading-[120%] text-left pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-6",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full !aspect-square sm:!w-[256px] sm:!h-[256px] relative",
          media: "w-full h-full object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col pt-4 bg-transparent",
          title: "text-[#000000] font-['OswaldMedium'] text-[22px] leading-[120%] text-left",
          subtitle:
            "text-[#000000] font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-left mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#8d8d8d]",
        sectionTitle:
          "text-[#000000] font-['OswaldMedium'] text-[28px] leading-[120%] text-left pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[420px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer:
            "w-full !aspect-video sm:!aspect-auto sm:!w-[228px] sm:!h-[128px] sm:flex-shrink-0 relative",
          media: "w-full h-full object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:pl-3 sm:pr-0 py-4 sm:!py-0 bg-transparent",
          title:
            "text-[#000000] font-['OswaldMedium'] text-[22px] sm:text-[18px] leading-[120%] text-left",
          subtitle:
            "text-[#000000] font-['NeuzeitOfficeRegular'] text-[15px] sm:text-[12px] leading-[110%] text-left mt-2",
          location:
            "text-[#000000] font-['NeuzeitOfficeRegular'] text-[15px] sm:text-[12px] leading-[110%] text-left mt-1",
          date: "text-[#000000] font-['NeuzeitOfficeRegular'] text-[15px] sm:text-[12px] leading-[110%] text-left mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#000000] font-['OswaldRegular'] text-[28px] leading-[120%] text-left",
        text: "text-[#222222] font-['NeuzeitOfficeRegular'] text-[17px] leading-[110%] text-left",
        customShopImageStyle: "!h-auto aspect-video sm:!w-[420px] sm:!h-[236px]",
        sectionTitle:
          "text-[#000000] font-['OswaldMedium'] text-[28px] leading-[120%] text-left !mb-4 sm:!mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ebebeb] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-8 sm:p-8 p-4 border-b border-[#8d8d8d]",
        media:
          "!w-full !h-auto aspect-video sm:!w-[320px] sm:!h-[180px] object-cover !border-0 sm:mb-4",
        title: "text-[#000000] font-['OswaldMedium'] text-[28px] leading-[120%] text-left",
        subtitle:
          "text-[#000000] font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-left mb-4 mt-2",
        button:
          "bg-[#ca3c3a] border-2 border-[#ca3c3a] px-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['OswaldMedium'] !text-[17px] leading-[100%] uppercase text-left !h-[50px] sm:!h-[50px]",
        questions:
          "!text-[#000000] font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-left",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#8d8d8d]",
        header: "text-[#000000] font-['OswaldRegular'] text-[28px] leading-[120%] text-left",
        text: "text-[#222222] font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#8d8d8d]",
        header: "text-[#000000] font-['OswaldRegular'] text-[28px] leading-[120%] text-left",
        text: "text-[#222222] font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-left mb-4 max-w-[652px] w-full",
        map: "!w-full !h-auto aspect-video sm:!w-[350px] sm:!h-[197px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#ca3c3a",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['OswaldRegular'] text-[28px] leading-[120%] text-left",
        text: "text-[#222222] font-['NeuzeitOfficeRegular'] text-[17px] leading-[110%] text-left",
      },
      tickets: {
        header:
          "text-[#000000] font-['OswaldRegular'] text-[28px] leading-[120%] text-left px-4 sm:px-8 pt-4 sm:pt-8 mb-2 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ebebeb] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff00] border border-[#ca3c3a] flex items-center justify-center px-[12px] text-[#ca3c3a] font-['OswaldMedium'] text-[15px] leading-[100%] uppercase !w-fit !h-9 sm:!h-9",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto bg-[#ffffff00] border-b border-[#8d8d8d] overflow-hidden py-2 sm:py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['OswaldMedium'] text-[18px] leading-[120%] text-left mb-1",
          description:
            "text-[#000000] font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-left mb-1 flex flex-row",
          price: "text-[#000000] font-['OswaldMedium'] text-[18px] leading-[120%] text-left",
          status: "text-[#000000] font-['OswaldMedium'] text-[18px] leading-[120%] text-left",
          counterContainer:
            "bg-[#ffffff00] border border-[#ca3c3a] !px-[12px] gap-x-[16px] !w-fit !h-9",
          quantity:
            "text-[#ca3c3a] font-['OswaldMedium'] text-[15px] leading-[100%] uppercase text-left items-center",
          plusMinusColor: "#ca3c3a",
          button:
            "bg-[#ffffff00] border border-[#ca3c3a] flex items-center justify-center px-[12px] text-[#ca3c3a] font-['OswaldMedium'] text-[15px] leading-[100%] uppercase !w-fit !h-9 sm:!h-9",
        },
      },
    },
    comingSoon: {
      bgColor: "#ebebeb",
      hero: {
        desktop: `${S3_PREFIX}web-background.jpg`,
        mobile: `${S3_PREFIX}web-background-mobile.jpg`,
        style: "bg-[#C8C8C8]",
      },
      // Wide wordmark exported from the Figma waitlist frames: black on the grey panel, white over the mobile hero
      logo: {
        desktop: `${S3_PREFIX}coming-soon-logo.png`,
        mobile: `${S3_PREFIX}coming-soon-logo-mobile.png`,
        style: "w-[126px] h-[32px] sm:w-[180px] sm:h-[46px] object-contain",
      },
      werzLogoColor: "#000000",
      title: "font-['OswaldMedium'] text-[28px] leading-[120%] text-[#000000]",
      text: "font-['NeuzeitOfficeRegular'] text-[17px] leading-[110%] text-[#222222]",
      button:
        "bg-[#ca3c3a] border-2 border-[#ca3c3a] p-3 font-['OswaldMedium'] text-[15px] leading-[100%] uppercase text-[#ffffff] cursor-pointer w-fit",
      input: {
        base: "font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-[#000000] w-[256px] px-4 h-[41px] bg-white",
        border: "#6d6d6d",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-[#FF0000]",
      footerText: "font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-[#000000]",
      skipButton:
        "font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-[#222222] cursor-pointer",
      modal: {
        container: "bg-[#ebebeb] px-[40px] py-[48px]",
        title: "font-['OswaldRegular'] text-[28px] leading-[120%] text-[#000000] text-center",
        text: "font-['NeuzeitOfficeRegular'] text-[15px] leading-[110%] text-[#222222] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/75",
        otpInput:
          "!w-[40px] !h-[51px] rounded-[8px] text-[#000000] bg-white font-['NeuzeitOfficeRegular'] text-[17px] leading-[110%] text-center",
        otpBorder: "#6d6d6d",
        otpBorderFocus: "#000000",
      },
    },
  },
}

export default CUDDLES
